__turbopack_context__.v({
  "ManualHeader": "bfpcMW_ManualHeader",
  "ManualHeader__BackLink": "bfpcMW_ManualHeader__BackLink",
  "ManualHeader__BackText": "bfpcMW_ManualHeader__BackText",
  "ManualHeader__Container": "bfpcMW_ManualHeader__Container",
  "ManualHeader__Logo": "bfpcMW_ManualHeader__Logo",
  "ManualHeader__Search": "bfpcMW_ManualHeader__Search",
  "ManualHeader__Search--Open": "bfpcMW_ManualHeader__Search--Open",
  "ManualHeader__SearchToggle": "bfpcMW_ManualHeader__SearchToggle",
});
